import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { finalize } from 'rxjs';

import { Milestone } from '../schemas';
import { Messenger, ProductService } from '../service';

export interface RemoveMilestoneData {
  item: Milestone;
  ownerId: string;
}

@Component({
  selector: 'lcm-remove-milestone-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatProgressBarModule],
  template: `
    <h2 mat-dialog-title>Remove milestone</h2>
    <mat-dialog-content> Are you sure you want to remove the milestone "{{ data.item.Name }}"? </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close [disabled]="pending()">Cancel</button>
      <button matButton [disabled]="pending()" (click)="remove()">Confirm</button>
    </mat-dialog-actions>

    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
  styles: ``,
})
export class RemoveMilestoneDialog {
  data = inject(MAT_DIALOG_DATA) as RemoveMilestoneData;
  hostDialog = inject(MatDialogRef);
  messenger = inject(Messenger);

  productService = inject(ProductService);

  pending = signal(false);

  remove() {
    this.pending.set(true);

    this.productService
      .deleteMilestone(this.data.ownerId, this.data.item.Id)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: () => this.hostDialog.close(true),
        error: this.messenger.handleHttpError,
      });
  }
}
